import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';

export const RenderReactCell = (component: React.ReactNode): HTMLElement => {
  const container = document.createElement('div');
  const root = createRoot(container);
  flushSync(() => {
    root.render(component);
  });
  return container;
};

export default RenderReactCell;
